export default __webpack_public_path__ + "static/media/set-normal-4.c198eb9e.png";